const bizConfig = {
    enableVip: false // 是否启用VIP功能
};

export default bizConfig;
